/*
 * custom: sort-proxy — drives every "Sort" control (grid top and the
 * sticky tools strip) by mirroring its value into Dawn's own sort
 * select and firing the `input` event the facets form listens for.
 * Dawn then performs the fetch, URL update and grid swap.
 *
 * Delegated on document, so controls keep working after Dawn replaces
 * the facets markup on re-render. The snippet may be rendered twice
 * on a page, so guard against double execution.
 */
(() => {
  'use strict';
  if (window.customSortProxyLoaded) return;
  window.customSortProxyLoaded = true;

  const PROXY = '[data-custom-sort-proxy]';
  const THEME_SORT = '#SortBy-mobile, #SortBy';

  document.addEventListener('change', (event) => {
    const proxy = event.target.closest && event.target.closest(PROXY);
    if (!proxy) return;
    const themeSort = document.querySelector(THEME_SORT);
    if (!themeSort || themeSort === proxy) return;
    themeSort.value = proxy.value;
    themeSort.dispatchEvent(new Event('input', { bubbles: true }));
  });

  // After a re-render the authoritative value lives on Dawn's select;
  // re-sync every proxy (the grid-top one is itself re-rendered, the
  // sticky strip's persists in the header).
  document.addEventListener('custom:grid-rerendered', () => {
    const themeSort = document.querySelector(THEME_SORT);
    if (!themeSort || !themeSort.value) return;
    document.querySelectorAll(PROXY).forEach((proxy) => {
      proxy.value = themeSort.value;
    });
  });
})();
